import makeService from './api';

export default makeService('prod_files');
